import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  App,
  Button,
  Dropdown,
  Popconfirm,
  Popover,
  Space,
  Tag,
  Tooltip,
} from 'antd';
import React, { useRef, useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { ModalSupplier } from '../../components/upeosoft/ModalApp/ModalApp';
import { deleteSupplier, getSupplier } from '../../network/supplier';
import { useSelector } from 'react-redux';
import PropsSearchTable from '../../components/common/PropsSearchTable/PropsSearchTable';
import { RiUserLocationFill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import DashboardCards from '../Dashboard/DashboardCards';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';

const SupplierGroup = ({ t }) => {
  const { currentLang } = useSelector((state) => state?.user);
  const client = useQueryClient();
  // const [searchText, setSearchText] = useState('');
  const [editId, setEditId] = useState('');
  const navigate = useNavigate();
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const { message } = App.useApp();
  const searchInput = useRef(null);
  const searchInputMobile = useRef(null);
  const [textValue, setTextValue] = useState('');
  const [searchText, setSearchText] = useState({
    value: '',
    key: '',
  });
  const handleSearch = (selectedKeys, confirm, key) => {
    confirm();
    console.log(`Searching for: ${selectedKeys[0]}, key: ${key}`);
    setSearchText({ value: selectedKeys[0], key });
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText({ value: '', key: '' });
  };
  const props = ({ key, name }) =>
    PropsSearchTable({
      key: key,
      name: name,
      setTextValue: setTextValue,
      textValue: textValue,
      setSearchText: setSearchText,
      searchInputMobile: searchInputMobile,
      searchInput: searchInput,
      handleSearch: handleSearch,
      handleReset: handleReset,
      t: t,
    });
  const handleRemove = useMutation({
    mutationFn: (id) => deleteSupplier(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message ? data?.message : 'Deleted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getSuppliers] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getSuppliers, searchText.key, searchText.value],
    queryFn: () =>
      getSupplier({
        key: searchText.key,
        value: searchText.value,
      }),
    keepPreviousData: true,
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit + ' ' + t.Supplier,
      icon: <MdModeEditOutline />,
      onClick: () => {
        setEditId(record?.name);
        setOpen(true);
        setEdit(true);
      },
    },
    {
      key: '2',
      label: t.addAddress,
      icon: <RiUserLocationFill />,
      onClick: () => {
        navigate(`/address?open=true&Supplier=${record?.name}`);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.DeletetheSupplier + ` (${record?.name})`}
          description={t.areYouSure}
          onConfirm={() => handleRemove.mutate(record?.name)}
          okText={t.yes}
          cancelText={t.no}
        >
          <span style={{ color: 'red' }}>
            {t.Delete} {t.Supplier}
          </span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.Name,
      dataIndex: 'supplier_name',
      // currentLang === 'en' ? 'supplier_name' : 'supplier_name_in_arabic',
      // key: currentLang === 'en' ? 'supplier_name' : 'supplier_name_in_arabic',
      key: 'supplier_name',
      ...props({ key: 'supplier_name', name: t.Name }),
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              setEditId(record?.name);
              setOpen(true);
              setEdit(true);
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: t.country,
      dataIndex: 'country',
      key: 'country',
      ...props({ key: 'country', name: t.country }),
    },
    // {
    //   title: t.SupplierGroup,
    //   dataIndex: 'supplier_group',
    //   ...props({ key: 'supplier_group', name: t.SupplierGroup }),
    //   // render: (text, record) => {
    //   //   return text ? <Tag color="green">Yes</Tag> : <Tag color="red">No</Tag>;
    //   // },
    // },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 100,
      render: (text, record) => {
        return (
          <Space>
            {/* <Button
              size="small"
              type="primary"
              onClick={() => {
                setEditId(record?.name);
                setOpen(true);
                setEdit(true);
              }}
              icon={<MdModeEditOutline />}
            />
            <Tooltip title={t.addAddress}>
              <Button
                size="small"
                type="primary"
                style={{
                  backgroundColor: '#2F80ED',
                }}
                onClick={() => {
                  navigate(`/address?open=true&Supplier=${record?.name}`);
                }}
                icon={<RiUserLocationFill />}
              />
            </Tooltip>
            <Popconfirm
              title={t.DeletetheSupplier + ` (${record?.name})`}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record?.name)}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger icon={<MdDelete />} />
            </Popconfirm> */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="inventory">
      {/* <Heading title={t.Inventory} subTitle={t.Suppliers} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          Placeholder={t.searchByName}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                setOpen(true);
                setEdit(false);
              }}
            >
              <PlusOutlined
                style={{
                  fontSize: '10px',
                }}
              />
              {t.addSupplier}
            </Button>
          }
        />
      </div>
      <ModalSupplier
        open={open}
        setOpen={setOpen}
        edit={edit}
        editId={editId}
        t={t}
        setEdit={setEdit}
      />
    </div>
  );
};

export default SupplierGroup;
